import React from 'react';
import { withCookies } from 'react-cookie';

import "./pclogin.css";

class PcLoginPage extends React.Component {

    render() {
        return <div className="main_wrap">
        	<div className="login_box">
	        	<div className="loginBody">
	        		<div className="weixin_login">
		        		<a className="weixin_login_link" href={ process.env.API_HOST + '/account/login.html?redirect=' + process.env.MAIN_HOST }>
		        			<img src={require("../../common/images/logo_weixin.png")} className="weixin_logo"></img>
		        			<p className="title_text">企业微信扫码登录</p>
		        			<p className="enter_text">点击进入</p>
		        		</a>
	        		</div>
	        	</div>
        	</div>
        	<div className="page_footer">
				{/* 北京云测信息技术有限公司 京ICP证150088号 */}
        		<p style={{fontSize:10}}>©2011-<span id="copyrightYear">2025</span></p>
        	</div>
        </div>;
    }

}

export default withCookies(PcLoginPage);